import React, { useEffect , useState, useRef } from "react";
import { Dialog, DialogContent, DialogActions, DialogTitle, TextField, InputAdornment, Button, IconButton, Alert, AlertTitle, Box, FormHelperText, Paper, Grid } from "@mui/material";
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next'
import CloseIcon from '@mui/icons-material/Close';
/* REQUEST */
import { updateCategory } from "utils/Category";

const PaperComponent = (props) => {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const EditCategory = ({ open, setOpen, rows, selectedRow, setAlert, setOpenAlert, reloading }) => {
    const {t} = useTranslation()
    const [name, setName] = useState('')
    const [nameLength, setNameLength] = useState(0)
    const [alerts, setAlerts] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (open && selectedRow) {
            const select = rows.find(row => row.id === selectedRow[0])
            setName(select?.name)
        }
    }
    , [open, selectedRow, rows])

    const existName = (name) => {
        const select = rows.find(row => row.id === selectedRow[0])
        // Si el nombre no ha cambiado del original, no debe considerarse como existente
        if (select && String(select.name).toLowerCase() === String(name).toLowerCase().trim()) {
            return false;
        }

        // Verifica si existe en otros registros
        return rows.some(row => String(row.name).toLowerCase() === String(name).toLowerCase().trim());
    }

    const closeForm = () => {
        setOpen(false)
        setName('')
        setNameLength(0)
    }

    const changes = () => {
        return name !== '' ? setAlerts(true) : closeForm()
    }

    const disabled = () => {
        return name === '' || existName(name)
    }

    const editCategory = async () => {
        setLoading(true)

        try {
            const response = await updateCategory(selectedRow[0], name)
            if (response.length > 0) {
                setOpenAlert(true)
                setAlert({
                    severity: 'success',
                    msg: t('custom_reports.category.table.dialog.edit.messages.success')
                })
                closeForm()
                reloading()
                setLoading(false)
            }
        } catch (error) {
            setOpenAlert(true)
            setAlert({
                severity: 'error',
                msg: t('custom_reports.category.table.dialog.edit.messages.error')
            })
            setLoading(false)
        }
    }
    return (
        <Dialog
            maxWidth="xs"
            fullWidth
            open={open}
            PaperComponent={PaperComponent}
            onClose={(event, reason) =>{
                if(reason !== 'backdropClick') {
                    return;
                }
                changes()
            }}
            aria-labelledby="draggable-dialog-title"
            aria-describedby="draggable-alert-dialog-description"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{t('custom_reports.category.table.dialog.edit.title')}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => changes()}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <Box sx={{ top : 0, zIndex: 10, pb: 1}}>
                {
                    alerts &&
                        <Alert
                            variant='filled'
                            severity="warning"
                            sx={{ mt: 2 }}
                            action={
                                <>
                                    <Button onClick={() => closeForm()} color="inherit" size="small" variant='text' disableElevation>
                                        {t('custom_reports.category.table.dialog.edit.alert.unsaved_changes.buttons.yes')}
                                    </Button>
                                    <Button onClick={() => setAlerts(false)} color='inherit' size='small' variant='text' disableElevation>
                                        {t('custom_reports.category.table.dialog.edit.alert.unsaved_changes.buttons.no')}
                                    </Button>
                                </>
                            }
                        >
                            <AlertTitle>{t('custom_reports.category.table.dialog.edit.alert.unsaved_changes.message')}</AlertTitle>
                        </Alert>
                }
            </Box>
        <DialogContent dividers>
            <Grid container>
                <Grid size={{ xs: 10, sm: 12, md: 12, lg: 12 }}>
                    <TextField
                        id={'input-name'}
                        fullWidth
                        label={t('custom_reports.category.table.dialog.edit.name')}
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value)
                            setNameLength(e.target.value.length)
                            existName(e.target.value)
                        }}
                        placeholder={t('custom_reports.category.table.dialog.edit.max_name')}
                        required
                        error={existName(name)}
                        slotProps={{
                            htmlInput: { maxLength: 100 },
                            input: {
                                endAdornment: <InputAdornment position="end">{`${nameLength}/100`}</InputAdornment>,
                            },
                        }}
                    />
                    <FormHelperText
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            mt: 0.5,
                            px: 1.75
                        }}
                    >
                        <span>{existName(name) ? t('custom_reports.category.table.dialog.edit.exist_name') : ''}</span>
                        {/* <span></span> */}
                    </FormHelperText>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" color="error" onClick={() => changes()}>{t('custom_reports.category.table.dialog.edit.buttons.cancel')}</Button>
            <Button variant="contained" color="primary" loading={loading} disabled={disabled()} onClick={() => editCategory()}>{t('custom_reports.category.table.dialog.edit.buttons.edit')}</Button>
        </DialogActions>
        </Dialog>
    )
}

export { EditCategory };